import React from "react";
import PhotoCreditPhotoUploadPage from "./PhotoCreditPhotoUploadPage";
import PhotoCreditOverlay from "./PhotoCreditOverlay";
import {default as t} from '../../utils/Translate';

const PhotoCreditBrands = props => (
  <div className="app-type app-spacers">
    <div className="app-view mb-md">
      <div className="photo-credit-container">
        <div className="photo-credit-container__title">
        {t('Mileage Credit: Shopping',props.lang)}
        </div>
        <div className="photo-credit-container__content">
          <div className="photo-credit-container__content-box">
            <div className="photo-credit-container__content-title">
            {t('Earn miles by photo credit', props.lang)}
            </div>
            <div className="photo-credit-container__content-paragraph">
            {t(`With these partners, you can have miles credited to you later for products you have purchased. For this purpose, upload photos of your purchase receipts according to the respective campaign.`, props.lang)}
            </div>
          </div>
          <div className="photo-credit-container__content-brand-list">
            <div className="photo-credit-container__content-brand">
              <img
                alt={props.partner}
                src={props.partnerLogo}
                className="photo-credit-container__content-brand-logo"
              />
              <div className="photo-credit-container__content-brand-data">
                <div className="photo-credit-container__content-brand-name">
                  {props.partner}
                </div>
                <div className="photo-credit-container__content-brand-tagline">
                  {props.campaign.main_benefit_offerpage}
                </div>
              </div>
              <div className="controls first">
                <div className="next"></div>
              </div>
            </div>
            <div className="photo-credit-container__content-brand">
              <div
                className="photo-credit-container__content-brand-logo background"
              ></div>
              <div className="photo-credit-container__content-brand-data">
                <div className="photo-credit-container__content-brand-name">
                  Partnername
                </div>
                <div className="photo-credit-container__content-brand-tagline">
                  {t(`XXX earn miles`, props.lang)}
                </div>
              </div>
              <div className="controls">
                <div className="next"></div>
              </div>
            </div>
            <div className="photo-credit-container__content-brand">
              <div
                className="photo-credit-container__content-brand-logo background"
              ></div>
              <div className="photo-credit-container__content-brand-data">
                <div className="photo-credit-container__content-brand-name">
                  Partnername
                </div>
                <div className="photo-credit-container__content-brand-tagline">
                {t(`XXX earn miles`, props.lang)}
                </div>
              </div>
              <div className="controls">
                <div className="next"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

const PhotoCredit = props => (
  <div className="photocredit-app">
    <PhotoCreditBrands partnerLogo={props.partnerLogo} partner={props.partner} campaign={props.campaign} {...props}/>
    <PhotoCreditPhotoUploadPage campaign={props.campaign} photoCredit={props.photoCredit} {...props}/>
    <PhotoCreditOverlay campaign={props.campaign} photoCredit={props.photoCredit} {...props}/>
  </div>
)

export default PhotoCredit;



// WEBPACK FOOTER //
// ./src/components/ads/app/PhotoCredit.js